import IKeyValuePair from "features/shared/models/IKeyValuePair";

export enum DataGridActionTypes {    
    SET_GRID_FILTR_URLPARAMS_SAGA = "@@datagrid/SET_GRID_FILTR_URLPARAMS_SAGA",
    RESET_GRID_FILTR_URLPARAMS_SAGA = "@@datagrid/RESET_GRID_FILTR_URLPARAMS_SAGA",    
    SET_GRID_PAGINATION_URLPARAMS_SAGA = "@@datagrid/SET_GRID_PAGINATION_URLPARAMS_SAGA",
    RESET_GRID_PAGINATION_URLPARAMS_SAGA = "@@datagrid/RESET_GRID_PAGINATION_URLPARAMS_SAGA",
    SET_GRID_PAGINATION_PAGE_SIZE_SAGA = "@@datagrid/SET_GRID_PAGINATION_PAGE_SIZE_SAGA",
    SET_GRID_SORTING_URLPARAMS_SAGA = "@@datagrid/SET_GRID_SORTING_URLPARAMS_SAGA",
    COMPUTE_GRID_URLPARAMS = "@@datagrid/COMPUTE_GRID_URLPARAMS",
    RESET_ALL_GRIDS = "@@datagrid/RESET_ALL_GRIDS"
}

export type DataGridAction =    
     { type: DataGridActionTypes.SET_GRID_FILTR_URLPARAMS_SAGA, data: IKeyValuePair<string, string> }    
    | { type: DataGridActionTypes.RESET_GRID_FILTR_URLPARAMS_SAGA, data: string }
    | { type: DataGridActionTypes.SET_GRID_PAGINATION_URLPARAMS_SAGA, data: IKeyValuePair<string, string> }
    | { type: DataGridActionTypes.RESET_GRID_PAGINATION_URLPARAMS_SAGA, data: string }
    | { type: DataGridActionTypes.SET_GRID_PAGINATION_PAGE_SIZE_SAGA, data: IKeyValuePair<string, number> }
    | { type: DataGridActionTypes.SET_GRID_SORTING_URLPARAMS_SAGA, data: IKeyValuePair<string, string> }
    | { type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: IKeyValuePair<string, string> }
    | { type: DataGridActionTypes.RESET_ALL_GRIDS }

export const setGridUrlParams = (data: IKeyValuePair<string, string>): DataGridAction => {
    return {
        type: DataGridActionTypes.SET_GRID_FILTR_URLPARAMS_SAGA,
        data: data
    }
}

export const resetGridUrlParams = (data: string): DataGridAction => {
    return {
        type: DataGridActionTypes.RESET_GRID_FILTR_URLPARAMS_SAGA,
        data: data
    }
}

export const setGridPaginationUrlParams = (data: IKeyValuePair<string, string>): DataGridAction => {
    return {
        type: DataGridActionTypes.SET_GRID_PAGINATION_URLPARAMS_SAGA,
        data: data
    }
}

export const resetGridPaginationUrlParams = (data: string): DataGridAction => {
    return {
        type: DataGridActionTypes.RESET_GRID_PAGINATION_URLPARAMS_SAGA,
        data: data
    }
}

export const setGridPaginationPageSize = (data: IKeyValuePair<string, number>): DataGridAction => {
    return {
        type: DataGridActionTypes.SET_GRID_PAGINATION_PAGE_SIZE_SAGA,
        data: data
    }
}

export const setGridSortingUrlParams = (data: IKeyValuePair<string, string>): DataGridAction => {
    return {
        type: DataGridActionTypes.SET_GRID_SORTING_URLPARAMS_SAGA,
        data: data
    }
}

export const computeGridUrlParams = (data: IKeyValuePair<string, string>): DataGridAction => {
    return {
        type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS,
        data: data
    }
}

export const resetAllGrids = (): DataGridAction => {
    return {
        type: DataGridActionTypes.RESET_ALL_GRIDS
    }
}